import React from 'react';
import { Brain } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy relative overflow-hidden py-8 border-t border-white/10" data-id="element-40">
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20" data-id="element-41">
        <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-yellow blur-3xl" data-id="element-42" />
        <div className="absolute bottom-10 right-10 w-48 h-48 rounded-full bg-terracotta blur-3xl" data-id="element-43" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-44">
        <div className="flex justify-center mb-6" data-id="element-45">
          <Brain className="w-10 h-10 text-yellow animate-pulse" data-id="element-46" />
        </div>

        <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-3" data-id="element-47">
          Tu mente no tiene que estar en guerra contigo.
        </h2>

        <p className="text-lg text-offwhite/70 mb-8" data-id="element-48">
          120 segundos pueden cambiar cómo experimentas el mundo social.
        </p>

        <a href="https://pay.hotmart.com/P104890681K?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block bg-red-600 hover:bg-red-700 text-white font-heading font-bold text-lg py-5 px-10 rounded-full shadow-lg animate-heartbeat" data-id="element-49">
          QUIERO LA SOLUCIÓN DE RAÍZ — $140 MXN →
        </a>
      </div>
    </footer>;
}